import React from "react";
import "./Timeline.css";

const Timeline = ({ children, className = "", ...props }) => {
    return (
        <div className={`custom-timeline ${className}`} {...props}>
            {children}
        </div>
    );
};

const TimelineItem = ({ children, className = "", ...props }) => {
    return (
        <div className={`timeline-item ${className}`} {...props}>
            <div className="timeline-marker"></div>
            <div className="timeline-content">
                {children}
            </div>
        </div>
    );
};

Timeline.Item = TimelineItem;

export default Timeline; 